import { OlkyPassCustomerStatus } from "@/molecules/olkypass-customer-status/label";
import { StaticLinkNatureRelationEnum } from "@/utils/static-data/nature-relation";
import { IdentityDocumentType } from "@/views/identity/components/level-card-status-container/verified-company-form/types";
import {
  DeclarativeNif,
  DeclarativeNifCompany,
  DeclarativeNifWithCountryUuid
} from "../flow/types";
import { KYCSessionStatus, Olkypass_status } from "../kyc/types";
import { LegalDocument } from "../user/document/types";
import {
  AdressWithCountryUuid,
  AliasEmail,
  AliasIBAN,
  AliasMobile,
  identityPartners,
  NaturalPerson,
  StaticNatureMandate
} from "../user/types";
import { DateWithTimezone } from "../utils/types";

export type LegalEntityCreateSchema = {
  data: DeclarativeNifCompany;
  legal_name: string | null;
  country_incorporation_id: string | null;
  date_incorporation: Date | null;
  legal_form: string | null;
  csp_id: string | null;
  activity_code: string | null;
  legal_form_rcs: string | null;
  address: {
    country_id: string | null;
    address_1: string | null;
    zip_code?: string | null | undefined;
    city?: string | null | undefined;
    tag?: string | null | undefined;
    isPrincipalAddress?: boolean | undefined;
  };
  agent_nature_relation?: AgentNatureMandate;
  agent_nature_relation_other?: string;
  is_communication_contact?: boolean;
  is_agent_le?: boolean;
  RCS_number?: string | null | undefined;
  address_activity?:
    | {
        country_id: string | null;
        address_1: string | null;
        address_2?: string | null | undefined;
        address_3?: string | null | undefined;
        zip_code?: string | null | undefined;
        city?: string | null | undefined;
        tag?: string | null | undefined;
        isPrincipalAddress?: boolean | undefined;
      }
    | undefined
    | null;
  website_url?: string | null | undefined;
  brand?: string | null | undefined;
  VAT_Number?: string | undefined;
  tax_address?: DeclarativeNifCompany | null;
  country_residence_id?: string | undefined;
  lei_number?: string | undefined | null;
  shareholder_is_legal_entity: boolean;
  mandate_services: MandateService[];
  agent_company_name?: string;
  selectedRcsRepresentative?: SelectedRcsRepresentative;
};
export type LegalEntityUpdateSchema = {
  data: DeclarativeNifCompany;
  legal_name: string | null;
  brand: string | null;
  country_incorporation_id: string | null;
  date_incorporation: DateWithTimezone;
  legal_form: string | null;
  legal_form_rcs: string | null;
  csp_id: string | null;
  activity_code: string | null;
  address: {
    country_id: string | null;
    address_1: string | null;
    zip_code?: string | null | undefined;
    city?: string | null | undefined;
    tag?: string | null | undefined;
    isPrincipalAddress?: boolean | undefined;
  };
  agent_nature_relation: AgentNatureMandate | null;
  is_communication_contact: boolean;
  is_agent_le: boolean;
  RCS_number?: string | null | undefined;
  address_activity?:
    | {
        country_id: string | null;
        address_1: string | null;
        address_2?: string | null | undefined;
        address_3?: string | null | undefined;
        zip_code?: string | null | undefined;
        city?: string | null | undefined;
        tag?: string | null | undefined;
        isPrincipalAddress?: boolean | undefined;
      }
    | undefined
    | null;
  website_url?: string | null | undefined;
  VATNumber?: string | undefined;
  tax_address?: DeclarativeNifCompany | null;
  country_residence_id?: string | undefined;
  lei_number?: string | undefined | null;
  shareholder_is_legal_entity: boolean;
};
export type rcsGetPayloadRequest = {
  rcs?: string;
  country?: string;
};

export type RCSRepresentative = {
  link_type: string;
  first_name: string;
  last_name: string;
  birth_date: Date;
  agent_nature_relation: string;
  agent_nature_relation_other: string;
};

export type SelectedRcsRepresentative = {
  firstName: string;
  lastName: string;
  birthDate: Date;
};

export type rcsResponseType = {
  legalEntity: {
    RCS_number?: string | null | undefined;
    legal_name: string | null;
    legal_form: string | null;
    date_incorporation: Date | string;
    country_incorporation_id: string | null;
    address: {
      address_1: string | null;
      zip_code?: string | null | undefined;
      city?: string | null | undefined;
      country_id: string | null;
    };
  };
  representatives: RCSRepresentative[];
};

export type ProVerifiedUploadDocumentBody = {
  companyUuid: string;
  document?: LegalDocument;
  identityDocumentType?: IdentityDocumentType;
};

export type legal_entity = {
  UUID: string;
  LegalName: string | null;
  Brand: string | null;
  Country: string | null;
  LegalForm: string | null;
  LegalFormUuid: string | null;
  LegalFormRcs: string | null;

  RCSlocation: string | null;
  RCSnumber: string | null;
  IsIncorporated: string | null;
  DateOfIncorporation: DateWithTimezone | null;
  ShareCapital: number | null;
  IsListedOnStockExchange: string | null;
  PlaceOfQuotation: string | null;
  VATSubject: string | null;
  VATNumber: string | null;
  NIF: string | null;
  IdentityDocument: LegalDocument | null;
  Comments: string | null;
  ActivityCode: string | null;
  ActivityNaceUuid: string | null;
  CSPCode: string | null;
  CodeLangue: string | null;
  websiteUrl: string | null;
  AgentReviewFinish: Date | null;
  UserValidation: Date | null;
  is_waiting_consent: boolean;
  Address: AdressWithCountryUuid[];
  AddressActivity: AdressWithCountryUuid;
  AliasIBAN: AliasIBAN[];
  AliasEmail: AliasEmail[];
  AliasMobile: AliasMobile[];
  identityUuid: string | null;
  codeNace: string | null;
  CountryIncorporationId: number | null;
  CountryIncorporationUuid: string | null;
  CountryResidenceId: string | null;
  LeiNumber: string | null;
  ActivityRequiredAgreement: boolean | null;
  AmlObligations: boolean | null;
  CompanyIban: string | null;
  AddressDocument: string | null;
  SecondIdentityDocument: LegalDocument | null;
  RbeDocument: LegalDocument | null;
  OrganizationalDocument: LegalDocument | null;
  FiancialYearDocument: LegalDocument | null;
  HqDocument: LegalDocument | null;
  FinancialKpiDocument: LegalDocument | null;
  ProofFinancialKpiDocument: string | null;
  RegistryActionSaDocument: string | null;
  TaxAddress: DeclarativeNifCompany | DeclarativeNif;
  tax_address: DeclarativeNifWithCountryUuid | null;
  IsWaitingConsent: boolean;
  PaymentDueAmount: number | null;
  ShareholderIsLegalEntity: boolean | null;
};
export type CompanyQueryListResponse = {
  success: boolean;
  data: LegalEntityFrontDto[];
};

export type emailInvitSchema = {
  linkOlkyPassProUuid: string;
  companyUuid: string;
  email?: string;
  lang: string;
};

export type LinkList = {
  link: Link;
  natural_person: NaturalPerson;
  olkypass: {
    active: false;
    missingData: [];
    missingDocuments: [];
    identityDocuments: null;
    ValidForPayIn: true;
    ValidForPayout: true;
    olkypass_status: Olkypass_status;
    olkypass_status_under_audit: Olkypass_status;
    olkyPassCustomerStatus: OlkyPassCustomerStatus | null;
  };
};

export type Link = {
  createdAt: Date;
  updatedAt: Date;
  UUID: string;
  OlkyPassUUID: string;
  IdentityUUID: string;
  SourceUUID: string | null;
  LinkType: OlkyPassProLinkType;
  BoPercentage: string | null;
  boNatureRelationOther: string | null;
  InvitationStatus: string | null;
  AgentNature: AgentNatureMandate | null;
  AgentNatureOther: string | null;
  BoNatureRelations: StaticLinkNatureRelationEnum[];
  IsCommunicationContact: boolean;
  IsAgentLe: boolean;
  LeAgentUpgradeOlkyPassAsk: Date | null;
  OlkyPassLvlRequire: number;
  MandateServices: MandateService[] | null;
  agent_company_name?: string;
};
export type LegalEntityFrontDto = {
  legal_entity: legal_entity;
  legal_entity_home_address: AddressLegalEntity;
  legal_entity_olkypass: {
    active: false;
    missingData: [];
    missingDocuments: [];
    identityDocuments: null;
    ValidForPayIn: true;
    ValidForPayout: true;
    olkypass_status: Olkypass_status;
    olkypass_status_under_audit: Olkypass_status;
  };
};

export type addRepresentative = {
  agent_nature_relation: AgentNatureMandate;
  agent_nature_relation_other?: string | null;
  is_communication_contact: boolean;
  is_agent_le: boolean;
  mandate_services: MandateService[];
  agent_company_name?: string;
};
export type CompanyResponse = {
  success: boolean;
  uuid: string | null;
  legal_name: string | null;
  home_address: {
    Address1: string | null;
    Address2: string | null;
    Address3: string | null;
    ZipCode: string | null;
    Country: string | null;
    City: string | null;
  };
};

export enum AgentNatureMandate {
  LEGAL_REPRESENTATIVE = "LEGAL_REPRESENTATIVE",
  FIDUCIARY_MANDATE = "FIDUCIARY_MANDATE",
  LEGAL_ADVICE_MANDATE = "LEGAL_ADVICE_MANDATE",
  CHARTERED_ACCOUNTANT_MANDATE = "CHARTERED_ACCOUNTANT_MANDATE",
  EMPLOYEE_OF_THE_COMPANY = "EMPLOYEE_OF_THE_COMPANY",
  JUDICIAL_AGENT = "JUDICIAL_AGENT",
  OTHER = "OTHER"
}

export enum OlkyPassProLinkType {
  AGENT = "AGENT",
  BENEFICIAL_OWNER = "BENEFICIAL_OWNER"
}

export enum MandateService {
  ALIASES_MANAGEMENT = "ALIASES_MANAGEMENT",
  KYPAY_WITHDRAW = "KYPAY_WITHDRAW"
}

export type FindOlkypassRelatedPersonCompanyType = {
  hasOlkypass: boolean | string | null;
  idOlkypass?: string | null;
};

export type AddressLegalEntity = {
  id: number;
  country_id: number | string;
  address_1: string | null;
  address_2: string | null;
  address_3: string | null;
  zip_code: string | null;
  city: string | null;
  tag: string | null;
  isPrincipalAddress: boolean;
};
export type companyAdminListType = {
  uuid: string;
  uuidLegal: string;
  legal_name: string;
  rcs: string;
  olkypass_lvl: number;
  olkypass_status: string;
  alerts: string[];
  bo_count: number;
  agent_count: number;
  agent_review_finish: boolean;
  user_validation: boolean;
};
export type companyAdminNewListType = {
  uuid: string;
  legal_name: string;
  uuidLegal: string;
  rcs: string;
  partner: string;
  alerts: string[];
  bo_count: number;
  date_updated: string;
  agent_count: number;
  olkypass_lvl: number;
  agent_review_finish: boolean;
  user_validation: boolean;
  situation: string;
};

export type LegalEntityLinkDto = {
  linkUuid: string;
  realIdentityUuid: string;
  mandatoryInformation: {
    isCommunicationContact: boolean;
    linkType: OlkyPassProLinkType;
    agentNatureRelation: AgentNatureMandate | null | undefined;
    isAgentLe: boolean | null | undefined;
    agentNatureRelationOther?: string | null | undefined;
    agentCompanyName: string | null | undefined;
    mandateServices: MandateService[] | null | undefined;
    boRelations: StaticLinkNatureRelationEnum[] | null | undefined;
    boPercentage: number | null | undefined;
    boRelationOther: string | null | undefined;
  };
  naturalPerson?:
    | {
        gender: string | null;
        birthState: string | null;
        birthCity: string | null;
        birthCountryUuid: string | null;
        firstName: string;
        lastName: string;
        birthDate: Date | undefined;
        countryOfCitizenshipUuid: string;
        cspUuid: string;
        homeAddress: {
          address1: string;
          countryUuid?: string | null | undefined;
          address2?: string | null | undefined;
          address3?: string | null | undefined;
          zipCode?: string | null | undefined;
          city?: string | null | undefined;
        };
        taxAddress:
          | {
              countryUuid?: string | null | undefined;
              tin?: string | null | undefined;
              isDirty?: boolean | null | undefined;
            }
          | null
          | undefined;
        commonName?: string | null | undefined;
        activityUuid?: string | null | undefined;
        mailAddress?: string | null | undefined;
        mobileCode?: string | null | undefined;
        phoneNumber?: string | null | undefined;
        identityJustificationUuid?: string | null | undefined;
        identityJustification: (LegalDocument & { isDirty?: boolean }) | null | undefined;
      }
    | null
    | undefined;
};
export type linkdef = {
  createdAt: Date;
  updatedAt: Date;
  UUID: string;
  OlkyPassUUID: string;
  SourceUUID: string | null;
  LinkType: OlkyPassProLinkType;
  BoPercentage: string | null;
  InvitationStatus: string | null;
  AgentNature: OlkyPassProLinkType;
  AgentNatureOther: string | null;
  BoNatureRelations: StaticNatureMandate[];
  IsCommunicationContact: boolean;
  IsAgentLe: boolean;
  LeAgentUpgradeOlkyPassAsk: Date | null;
  OlkyPassLvlRequire: number;
};

export type CompanyRelatedPersonEditDto = {
  link_type: OlkyPassProLinkType;
  agent_nature_relation?: AgentNatureMandate | null;
  agent_nature_relation_other?: string | null;
  mandate_services: MandateService[];
  bo_percentage?: string | null;
  is_communication_contact?: boolean;
  bo_relations?: string[];
  bo_nature_relation_other?: string;
  is_agent_le?: boolean;
  identity_justification?: LegalDocument | null | undefined;
  uuid: string;
  real_uuid?: string | null;
  agent_company_name?: string | null;
  statusLevel?: number | null;
};
export type CompanyRelatedPersonDtoRequest = {
  companyRelatedPersonDto: LegalEntityLinkDto;
  companyUuid: string;
};

export type authenticatedCompanyFormType = {
  ShareCapital: number | null;
  Comments: string | null;
  RbeDocument: LegalDocument | null;
  OrganizationalDocument: LegalDocument | null;
  FiancialYearDocument: LegalDocument | null;
  ActivityRequiredAgreement: boolean | null;
  AmlObligations: boolean | null;
  SecondIdentityDocument: LegalDocument | null;
  CompanyIban: string | null;
};

export type companyDetails = {
  legalEntity: legal_entity;
  olkyPassLevel: KYCSessionStatus;
  identityPartners: identityPartners[];
};

export enum Add_Company_Related_steps {
  ADD_0 = "ADD_0",
  ADD_1 = "ADD_1",
  ADD_2 = "ADD_2"
}

export type LinkedNp = {
  name: string;
  birthdate: string;
  status: string | null;
  olkypassRequiredLvl: number;
  olkypassLvl: number;
  auditPending: boolean | null;
  uuid: string;
  olkypassUuid: string | null;
  realIdentityUuid: string | null;
  olkypassAuditLvl: number | null;
  LeAgentUpgradeOlkyPassAsk: Date | null;
  agentNature: AgentNatureMandate;
  agentNatureOther: string | null;
  olkyPassCustomerStatus: OlkyPassCustomerStatus | null;
};

export type CheckJoinLegalEntityResponse = {
  legalEntityUuid: string;
  legalName: string;
  homeAddress: {
    address1: string | null;
    address2: string | null;
    address3: string | null;
    zipCode: string | null;
    countryAlpha2: string | null;
    city: string | null;
  };
};
export type GetLinkInfoRequest = {
  leUuid: string;
  linkUuid: string;
};
export type JoinLegalEntityRequest = {
  legalEntityUuid: string;
  agentNatureRelation?: AgentNatureMandate;
  agentNatureRelationOther?: string | null | undefined;
  agentCompanyName?: string | null;
  isAgentLe?: boolean;
  isCommunicationContact?: boolean;
  mandateServices: MandateService[];
};

export type DeclarativeCompanyAddress = {
  address: string;
  city: string;
  countryUuid: string;
  tag: string;
  zipCode: string;
  isMain: boolean;
};

export type DeclarativeCompany = {
  legalEntityUuid: string;
  rcsNumber?: string;
  legalName?: string;
  countryIncorporationUuid?: string;
  incorporationDate?: Date;
  legalFormUuid?: string;
  activityNaceUuid?: string;
  address?: DeclarativeCompanyAddress;
  activityAddress?: DeclarativeCompanyAddress;
  website?: string;
  brand?: string;
  vatNumber?: string;
  taxCountryUuid?: string;
  taxNumber?: string;
  leiNumber?: string;

  name?: string;
  base64docs?: string;
  documentTypeUuid?: string;
};

export type DeclarativeCompanyResponse = {
  success: boolean;
  data: null;
};

export type InitCardTransactionRequest = {
  lang: string;
};

export type InitCardTransactionResponse = {
  reference: string;
  sessionId: string;
};

export type CompanyPaymentRecords = {
  amount: number;
  date: Date;
}[];

export type CompanyPaymentInformations = {
  iban: string;
  bic: string;
  totalAmount: number;
  dueAmount: number;
  account: string;
  address: string;
  paymentRecords?: CompanyPaymentRecords;
};

export const LE_PAYMENT_DATA_NOT_FOUND_INTERNAL_CODE = 4011;
